import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import "../App.css";
import BannerSlider from "../components/BannerSlider";
import Navbar from "../components/Navbar";
import PageSubMenu from "../components/PageSubMenu";
import Footer from "../components/Footer";
import HomeContent from "../components/HomeContent";
import * as CommonFunctions from '../Service/CommonFunctions';
import { getPublicServerData } from '../Service/GetDataApi';
import SmartPage from './SmartPage';
import SmartPageContainer from "../components/SmartPageContainer";
import { Helmet } from 'react-helmet';

let pageFlag;
const baseUrl = "https://hochhuth-consulting.de";

const SITE_NAME = 'Hochhuth Consulting';
const HOME_TITLE = 'Hochhuth Consulting - Experts in Digital Transformation and Business Consulting';
const HOME_DESCRIPTION = 'Hochhuth Consulting specializes in digital transformation, agile project management, and business consulting. Partner with us to achieve your business goals.';
const HOME_KEYWORDS = 'Hochhuth Consulting, digital transformation, business consulting, project management, IT consulting, agile consulting, business transformation, governance consulting';

// CMS pages that exist only for internal testing must stay out of the index.
const NOINDEX_TITLES = [/^dt page title/i, /^test page/i];

const firstSentence = (html, limit = 160) => {
  const text = String(html || '').replace(/<[^>]*>/g, ' ').replace(/&nbsp;|​/g, ' ').replace(/\s+/g, ' ').trim();
  if (!text) return '';
  return text.length <= limit ? text : text.slice(0, text.lastIndexOf(' ', limit)) + '…';
};
export default function Home(props) {
  const PageTitle = props.Title;
  const { hash, pathname } = useLocation();


  // State variables to store fetched data
  const [smartPageData, setSmartPageData] = useState([]);
  const [backgroundImageHeader, setBackgroundImageHeader] = useState(null);
  const [containerListData, setContainerListData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [containerNottag, setcontainerNottag] = useState(false);
  // Which PageTitle the currently held data belongs to. Rendering the content
  // before this matches shows the previous page's banner/containers.
  const [loadedFor, setLoadedFor] = useState(null);

  useEffect(() => {
    // Navigating again before a fetch resolves would otherwise let the older
    // response land last and overwrite the newer page's data.
    let active = true;

    // Start fetching data on component mount
    async function fetchData() {
      // Drop the previous page's banner up front, otherwise it is briefly
      // re-rendered against the new page while the fetch is in flight.
      setBackgroundImageHeader(null);
      const smartData = await GetAllSmartMetaData('SmartMetaData');
      const containers = await GetAllContainerListData('ContainerList');
      if (!active) return;

      // Process and combine data
      const backgroundImage = GetBackgroundImage(smartData, containers);

      setSmartPageData(smartData);
      setContainerListData(containers);
      setBackgroundImageHeader(backgroundImage);
      setLoadedFor(PageTitle);
      setLoading(false);
    }

    fetchData();
    return () => { active = false; };
  }, [PageTitle]);

  // Hash targets (#section-team, #what-we-offer, ...) live inside children that
  // render only once their own fetches resolve, so the browser's scroll on
  // navigation fires while the element still does not exist. Retry until it does.
  useEffect(() => {
    const id = decodeURIComponent((hash || '').replace('#', ''));
    if (!id) return;

    let cancelled = false;
    const abort = () => { cancelled = true; };
    // Never yank the page away from someone who has started scrolling themselves.
    window.addEventListener('wheel', abort, { passive: true, once: true });
    window.addEventListener('touchmove', abort, { passive: true, once: true });

    const STEP = 120;
    const QUIET_TICKS = 9; // ~1.1s of no layout movement counts as settled
    const deadline = Date.now() + 8000;
    let timer;
    let lastTop = null;
    let lastHeight = null;
    let stableFor = 0;

    const jump = (el) => {
      // 'auto', not 'smooth': jumping straight to the section avoids animating
      // the whole page past everything in between.
      window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY, behavior: 'auto' });
    };

    // The children below fetch independently and land in waves, each one
    // pushing the target further down. Scrolling before that stops means the
    // page keeps shifting under the reader, which is the jumping. So stay put
    // until the layout is quiet, jump once, then re-pin if anything still moves.
    const settle = () => {
      if (cancelled) return;
      const el = document.getElementById(id);
      if (el) {
        const top = Math.round(el.getBoundingClientRect().top + window.scrollY);
        const height = Math.round(document.body.scrollHeight);
        stableFor = (top === lastTop && height === lastHeight) ? stableFor + 1 : 0;
        lastTop = top;
        lastHeight = height;

        if (stableFor >= QUIET_TICKS || Date.now() >= deadline) {
          jump(el);
          // One late correction, in case a straggler shifted the layout.
          timer = setTimeout(() => {
            if (cancelled) return;
            const again = document.getElementById(id);
            if (again && Math.abs(again.getBoundingClientRect().top) > 2) jump(again);
          }, 600);
          return;
        }
      }
      if (Date.now() < deadline) timer = setTimeout(settle, STEP);
    };
    timer = setTimeout(settle, STEP);

    return () => {
      cancelled = true;
      clearTimeout(timer);
      window.removeEventListener('wheel', abort);
      window.removeEventListener('touchmove', abort);
    };
  }, [PageTitle, loadedFor, hash]);

  // Function to decode URL string
  function decodeURLString(encodedString) {
    // return decodeURIComponent(encodedString);
    const decoded = decodeURIComponent(encodedString);
    return decoded.replace(/-/g, ' ');
  }

  // Fetch smart meta data and filter by title
  const GetAllSmartMetaData = async (tableName) => {
    // Deliberately not resetting containerNottag here: doing so renders the
    // SmartPage branch for the duration of the fetch, so navigating between
    // pages visibly flips through the wrong layout before settling.
    pageFlag = false;
    const smartdata = await getPublicServerData(tableName);
    const updatedSmartData = await Promise.all(
      smartdata.map(async (item) => {
        item.PageContainers = await CommonFunctions.parseJson(item.PageContainers);
        if (item.Title.toLowerCase() === decodeURLString(PageTitle).toLowerCase()) {
          if (item.PageContainers != undefined && item.PageContainers.length > 0) {
            //setcontainerNottag(true)
            pageFlag = true;
          }
          return item;
        }
        return null;
      })
    );
    return updatedSmartData.filter(item => item !== null);
  };

  // Fetch container list data
  const GetAllContainerListData = async (tableName) => {
    const containerdata = await getPublicServerData(tableName);
    const updatedContainerData = await Promise.all(
      containerdata.map(async (item) => {
        item.ComponentConfiguration = await CommonFunctions.parseJson(item.ComponentConfiguration);
        item.TemplateConfiguration = await CommonFunctions.parseJson(item.TemplateConfiguration);
        return item;
      })
    );
    return updatedContainerData.filter(item => item !== null);
  };

  // Find the background image header from the data
  const GetBackgroundImage = (smartData, containers) => {
    let backgroundImage = null;

    smartData.forEach(smartItem => {
      containers.forEach(item => {
        smartItem.PageContainers.forEach(pageItem => {
          if (pageItem.Title === item.Title && item.TemplateConfiguration.selectedType === "BackgroundImage") {
            backgroundImage = item;
          }
        });
      });
    });
    setcontainerNottag(pageFlag);
    return backgroundImage;
  };

  // Per-page SEO. The CMS already carries seoTitle / metaDescription /
  // seoKeywords per page (currently empty), so prefer those and fall back to
  // values derived from the page itself rather than repeating the home page's.
  const seo = (() => {
    const page = smartPageData?.[0] || {};
    const name = (page.Title || decodeURLString(PageTitle) || '').trim();
    const isHome = name.toLowerCase() === 'home' || !name;
    const path = isHome ? '/' : pathname;

    const pick = (value, fallback) => (String(value || '').trim() || fallback);

    return {
      title: pick(page.seoTitle, isHome ? HOME_TITLE : `${name} | ${SITE_NAME}`),
      description: pick(page.metaDescription, firstSentence(page.Description) || HOME_DESCRIPTION),
      keywords: pick(page.seoKeywords, HOME_KEYWORDS),
      // Every page previously declared the home page as canonical, which tells
      // search engines they are all duplicates of it.
      canonical: `${baseUrl}${path}`,
      robots: NOINDEX_TITLES.some((re) => re.test(name)) ? 'noindex, nofollow' : 'index, follow',
    };
  })();

  return (
    <div id="wrapper" className="clearfix">
      <Helmet>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords} />
        <meta name="author" content="Hochhuth Consulting" />
        <meta name="robots" content={seo.robots} />
        <meta property="og:title" content={seo.title} />
        <meta property="og:description" content={seo.description} />
        <meta property="og:image" content={`${baseUrl}/images/hochhuth-banner.jpg`} />
        <meta property="og:url" content={seo.canonical} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Hochhuth Consulting" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seo.title} />
        <meta name="twitter:description" content={seo.description} />
        <meta name="twitter:image" content={`${baseUrl}/images/hochhuth-banner.jpg`} />
        <link rel="canonical" href={seo.canonical} />
      </Helmet>
      <Navbar />
      {loading || loadedFor !== PageTitle ? null : containerNottag ? (
        // Keyed on PageTitle so the content subtree is rebuilt on navigation;
        // these components hold per-page state that does not reset on prop change.
        <React.Fragment key={PageTitle}>

         <BannerSlider
          id={PageTitle}
          PageTitle={PageTitle}
          ContainerTitle={backgroundImageHeader?.Title}
          urlRoute={`/${PageTitle}`}
          btn=""
          mainpage="mainpage" />
          {/* <PageSubMenu />  */}
          <SmartPageContainer id={PageTitle} PageTitle={PageTitle} backgroundImageHeader={backgroundImageHeader?.Title} />
        </React.Fragment>
      ) : (<SmartPage />)}
      <Footer />
    </div>
  );
}
